import React from 'react'
import { Grid } from '@mui/material'

import type { HolidayPackageSummary } from '@/src/types/holidays'

import PackageCardWrapper from '../packageCard'

interface PackageGridProps {
    packages: HolidayPackageSummary[]
    collectionSlug: string
    /** Section the grid belongs to, reported as the card's `source_section`. */
    sourceSection: string
    isMobile: boolean
}

const PackageGrid: React.FC<PackageGridProps> = ({ packages, collectionSlug, sourceSection, isMobile }) => {
    return (
        // This theme redefines MUI's breakpoints — sm is 300px and md is 640px, not the default
        // 600/900. `sm: 6` would therefore put two narrow cards side by side on a phone. One column
        // below 640, two on tablet, three from 1024.
        <Grid container spacing={isMobile ? 2 : 3}>
            {packages.map((summary, index) => (
                <Grid key={summary.slug} size={{ xs: 12, md: 6, lg: 4 }}>
                    <PackageCardWrapper
                        summary={summary}
                        collectionSlug={collectionSlug}
                        sourceSection={sourceSection}
                        cardPosition={index + 1}
                        isMobile={isMobile}
                    />
                </Grid>
            ))}
        </Grid>
    )
}

export { PackageGrid }
export type { PackageGridProps }
export default PackageGrid
